import "./style.scss"
import InputAndApi from "./component/InputAndApi";

function App() {
  return (
   <div className='app'>
   <InputAndApi/>
   </div>
  );
}

export default App;
